import React, { useCallback, useContext } from 'react';
import styled, { css } from 'styled-components';
import { Arrow } from '@zocdoc-frontend-common/assets-icons';
import { Button } from '@zocdoc-frontend-common/components-button';
import { breakpoint } from '@zocdoc-frontend-common/styles-grid';
import {
    EVENT_INITIATORS,
    INTERACTION_TYPES,
} from '@zocdoc-frontend-common/utils-frontend-metrics';
import { blue100 } from '@zocdoc-mezzanine/foundations-colors';
import { CreateAccountNavigationContext } from 'src/Booking/components/CreateAccountContainer';
import { getMetricsCategoryFromPathname } from 'src/Booking/paths';

/**
 * @param {{
 *     inMobileHeader: boolean,
 *     sendMetric: function(input: Object): void,
 * }} props
 * @returns {JSX.Element}
 */
const BackButton = (props) => {
    // The loading page doesn't provide the context so we have to default {}
    const { goBackToPreviousPage } =
        useContext(CreateAccountNavigationContext) || {};

    const handleClickBack = useCallback(() => {
        props.sendMetric({
            action: 'Clicked back button',
            category: getMetricsCategoryFromPathname(window.location.pathname),
            component: 'Back button',
            element: 'Back button',
            initiator: EVENT_INITIATORS.USER,
            interactionType: INTERACTION_TYPES.CLICK,
            section: props.inMobileHeader ? 'Header' : 'Page body',
        });
        goBackToPreviousPage();
    }, [goBackToPreviousPage, props]);

    const StyledButton = props.inMobileHeader
        ? HeaderBackButton
        : BackButtonDesktop;

    return (
        <StyledButton
            data-test={
                props.inMobileHeader
                    ? 'header-back-button'
                    : 'page-body-back-button'
            }
            variation={Button.VARIATION.LINK}
            onClick={handleClickBack}
        >
            <StyledArrow
                direction={Arrow.direction.left}
                $inPageBody={!props.inMobileHeader}
            />
            {!props.inMobileHeader && 'Back'}
        </StyledButton>
    );
};

const HeaderBackButton = styled(Button)`
    color: ${blue100};
    font-size: 15px;
    position: absolute;
    top: 6px;
    left: 3px;
    ${breakpoint.small} {
        display: none;
    }
`;

const BackButtonDesktop = styled(Button)`
    display: none;
    color: ${blue100};
    font-size: 15px;
    margin: 0px 0px 0px 40px;
    position: absolute;
    text-align: center;
    ${breakpoint.small} {
        display: block;
    }
`;

const StyledArrow = styled(Arrow)`
    ${(p) =>
        p.$inPageBody &&
        css`
            height: 0.8em;
            margin-right: 8px;
        `};
`;

export default BackButton;
